<template>
  <div>
    <myHeader />
    <div id="result" class="test-result-box">
      <div class="test-result">
        <div class="test-result-1">您的信用自测结果为</div>
        <div class="test-result-2">{{ score }}</div>
        <div class="test-result-3">注：此处信用自测结果仅展示信用评分，若需要权威报告，则需要进行付费下载，请联系客服缴费。</div>
        <div class="test-result-4">
          <div class="btn test-save-storage mr20" @click="goBack">返回</div>
          <div class="btn primary-btn" @click="doContact">联系客服</div>
        </div>

      </div>
    </div>
    <myFooter bgc="black" />
    <!--联系客服-->
    <customer-service :dialogVisible="showDialog" @reset="showDialog = false" />
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "TestResult",
  data() {
    return {
      showDialog: false,
      score: 0
    }
  },
  watch: {},
  created() {
    let param = this.$route.params
    this.init(param.msg);
  },
  mounted() {
  },
  methods: {
    init(msg) {
      this.score = msg || Cookies.get("score")
      Cookies.set("score", msg)
    },
    goBack() {
      this.$router.go(-1)
    },
    doContact() {
      this.showDialog = true
    }
  }
}
</script>
<style scoped>
.test-result-box {
  padding-top: 110px;
  padding-bottom: 10px;
  width: 100%;
  min-height: 735px;
  background: rgba(244, 249, 253, 1);
}

.test-result {
  width: 1200px;
  height: 610px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.test-result-1 {
  font-size: 14px;
  font-weight: 400;
  margin: 118px auto 28px;
}

.test-result-2 {
  font-size: 72px;
  font-weight: 700;
  margin-bottom: 40px;
  color: rgba(63, 140, 255, 1);
}

.test-result-3 {
  width: 313px;
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(255, 141, 26, 1);
  margin-bottom: 45px;
}

.test-result-4 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/test/result.vue